import standardSections from './Standard-City';
import { cityMap } from './Cities';

const addedItems = new Map([
    ["Portable chairs, sunblock, hats, and bug spray would be helpful as well.", "Fremont can be pretty sunny."]
]);

const location = "The hunt will begin at Central Park in Fremont. " +
    "40000 Paseo Padre Pkwy, Fremont, CA 94538. REC AREA A.  " +
    "The closest parking is behind the Aqua Park The route will be around 4 miles in Downtown Fremont.  " +
    "<strong>There is special parking.  Please read your email.</strong>  Tickets are sold out.  No on-site purchases.";

const time = "We expect that most teams will solve all content in ~6 hours. DASH will start promptly at 9 am so please " +
    "arrive 20 minutes early to check in and receive your first puzzle. Typically teams break for lunch around noon, " +
    "and then complete the day around 5pm, at which point we will all migrate to The Counter for burgers and beers.";

const sections = standardSections("chen.jennifer.p@gmail.com", location, time, addedItems);



cityMap['fremont'].sections = sections;
cityMap['fremont'].eventStartLocation = "Central Park in Fremont. 40000 Paseo Padre Pkwy, Fremont, CA 94538. The route will be around 4 miles in Downtown Fremont.";



// WEBPACK FOOTER //
// ./src/cities/Fremont.js